// extracted by mini-css-extract-plugin
export default {"stepper":"stepper_stepper__zTW-4","stepNumberWrapper":"stepper_stepNumberWrapper__O7JBS","stepNumber":"stepper_stepNumber__EPMFc"};